import React from 'react'
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import GradeIcon from '@material-ui/icons/Grade';
import GradeOutlinedIcon from '@material-ui/icons/GradeOutlined';
import StandardList from "../Complements/StandardList"
import RenderDescriptionFormRedux from "../Complements/RenderDescriptionFormRedux"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    buttonFavorites: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid rgba(255, 198, 0)',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        width : "200px",
        fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
        }
    },
}));

const ElectronicRechargesInfoPanel = props => {

    const { listDetail, processPayment, getBack, isFavorites, saveFavorites } = props;

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                {
                    isFavorites ?
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<GradeIcon />}
                        className = { classes.buttonFavorites }
                    >Favorito</Button> :
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<GradeOutlinedIcon />}
                        onClick = { saveFavorites }
                        className = { classes.buttonFavorites }
                    >Agregar a favoritos</Button> 
                }
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <StandardList
                    dataList ={ listDetail}
                    primary = {'title'}
                    secondary = {'data'}
                    selectItem = {(val) => {/*console.log(val)*/}}
                    icon = {'school'}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <RenderDescriptionFormRedux  
                    label = "Concepto" 
                    onSubmit = {(data) => processPayment(data) } 
                    positive = {'Pagar'} 
                    getBack= {getBack}
                />
            </Grid>
        </Grid>
    )
}

ElectronicRechargesInfoPanel.propTypes = {
    listDetail: PropTypes.array.isRequired,
    processPayment: PropTypes.func.isRequired,
    getBack: PropTypes.func.isRequired,
    isFavorites: PropTypes.bool.isRequired,
    saveFavorites : PropTypes.func.isRequired
};

export default ElectronicRechargesInfoPanel
